import { Col, Divider, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import PageHeaderComponent from '../../../helpers/components/page_header.component';
import parkService from '../../../services/config/park.service';

const AddFreeAddOnRuleModal = ({ form, park, modal_visible, }) => {
    const [state, setState] = useState({
        loading : false,

        add_on_setups : [],
        ticket_applicable_users : [],

        selected_park_applicable_ticket_type_id : null,
        selected_add_on_setup_id : null,
    })

    const fetchTicketApplicableUser = async () => {
        setState(state => ({...state, loading : true, add_on_setups : [], selected_add_on_setup_id : null, }));
        form?.setFieldsValue({ add_on_setup_id : null, })
        if(park){
            const selected_park_applicable_ticket_type_id = state?.selected_park_applicable_ticket_type_id;
            if(selected_park_applicable_ticket_type_id){
                setState(state => ({...state, loading : true, }))
                const fetchParkApplicableTicketTypeResponse = await parkService?.getParkApplicableTicketTypeitems({
                    park_applicable_ticket_type_id : selected_park_applicable_ticket_type_id,
                    is_check_purchase_type : false,
                });

                const { park_applicable_add_ons, park_applicable_ticket_users, } = fetchParkApplicableTicketTypeResponse;
                setState(state => ({...state, loading : false, add_on_setups : park_applicable_add_ons, ticket_applicable_users : park_applicable_ticket_users, }))
            }
        }
    }

    useEffect(() => {
        fetchTicketApplicableUser();
    }, [state?.selected_park_applicable_ticket_type_id])

    return (
        <>
            <Form.Item label={'Name'} name={'name'}>
                <Input />
            </Form.Item>
            <Form.Item label={'Ticket Type'} name={'park_applicable_ticket_type_id'}>
                <Select
                onChange={(park_applicable_ticket_type_id) => setState(state => ({...state, selected_park_applicable_ticket_type_id : park_applicable_ticket_type_id, }))}
                options={park?.ticket_types?.map(x => ({ value : x?.ParkApplicableTicketType?.park_applicable_ticket_type_id, label : x?.name, }))}
                />
            </Form.Item>
            <Form.Item initialValue={false} label={'Is Adjustable'} name={'is_adjustable'}>
                <Switch />
            </Form.Item>

            <Divider style={{ margin : 0, marginBottom : 12, }} />
            <div>
                <PageHeaderComponent title={<span style={{ fontSize : 14, }}>Add On</span>} />
                <Row gutter={[12, 12]}>
                    <Col xs={24} md={12}>
                        <Form.Item label={'Entitled Quantity'} name={'free_add_on_quantity'}>
                            <InputNumber min={0} style={{ width : '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label={'Entitled Add On'} name={'add_on_setup_id'}>
                            <Select
                            // value={state?.selected_add_on_setup_id}
                            onChange={(add_on_setup_id) => setState(state => ({...state, selected_add_on_setup_id : add_on_setup_id, }))}
                            options={state?.add_on_setups?.map(x => ({ value : x?.add_on_setup_id, label : x?.add_on?.name, }))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>

            <Divider style={{ margin : 0, marginBottom : 12, }} />
            <div>
                <PageHeaderComponent title={<span style={{ fontSize : 14, }}>Condition For Ticket</span>} />
                <Row gutter={[12, 12]}>
                    <Col xs={24} md={12}>
                        <Form.Item label={'Minimum Required Quantity'} name={'min_required_ticket_quantity'}>
                            <InputNumber min={0} style={{ width : '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label={'Maximum Required Quantity'} name={'max_required_ticket_quantity'}>
                            <InputNumber min={0} style={{ width : '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={24}>
                        <Form.Item label={'Required Ticket'} name={'free_add_on_rule_requires'}>
                            <Select
                            mode='multiple'
                            options={state?.ticket_applicable_users?.map(x => ({ value : x?.ticket_applicable_user_id, label : x?.ticket_user_type?.name, disabled : (x?.ticket_applicable_user_id == state?.selected_free_ticket_applicable_user_id), }))}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default AddFreeAddOnRuleModal;